<div class="row mb-3">
	<div class="col-xs-12 col-md-12">
		<div class="row">
			<div class="col-12">
				<div class="d-flex align-items-center">
					<div class="mb-3">
						<input type="checkbox" class="form-check-input" id="includeDerivativeLines" name="includeDerivativeLines" [disabled]="isLoading" [(ngModel)]="includeDerivativeLines" (ngModelChange)="loadTree(2)"/>
						<label class="ms-1" for="includeDerivativeLines" jhiTranslate="pedigree.tree.include.derivative.lines">Include derivative and maintenance lines </label>
					</div>
					<button class="btn btn-info ms-2" [disabled]="isLoading" (click)="viewPedigreeGraph(gid)"><span jhiTranslate="pedigree.tree.view-pedigree-graph"></span></button>
					<button class="btn btn-info ms-2" [disabled]="isLoading" *ngIf="this.numberOfGenerations > 5" (click)="expandAll()"><span jhiTranslate="pedigree.tree.display-full-pedigree">Display Full Pedigree</span></button>
				</div>
			</div>
		</div>
		<div class="table-responsive pt-3 custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
			<label *ngIf="!isLoading && !isExpandAll && numberOfGenerations <= 5">{{numberOfGenerations}} {{ 'pedigree.tree.label.generation' | translate}}{{numberOfGenerations > 1 ? 's' : ''}}</label>
			<label *ngIf="!isLoading && !isExpandAll && numberOfGenerations > 5">5+ {{ 'pedigree.tree.label.generations' | translate}}</label>
			<label *ngIf="!isLoading && isExpandAll">{{numberOfGenerations}} {{ 'pedigree.tree.label.generations' | translate}}</label>
			<p-tree *ngIf="!isLoading else loading" [value]="nodes"
					(onNodeExpand)="onNodeExpand($event)"
					autoLayout="true"
					styleClass="tree-table">
				<ng-template pTemplate="default" let-node>
					<a *ngIf="node.data.id !== 0" [href]="this.germplasmDetailsUrlService.getUrl(node.data.id)" target="_blank"><span *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION"><truncate-span [textInput]="node.data.name" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></span> ({{node.data.id}})</a>
					<span *ngIf="node.data.id === 0"><span *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION"><truncate-span [textInput]="node.data.name" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></span> ({{node.data.id}})</span>
				</ng-template>
			</p-tree>
			<ng-template #loading>
				<div class="ui-tree d-flex align-items-center justify-content-center"><span class="throbber"></span></div>
			</ng-template>
		</div>
	</div>
</div>
